import React, { useState, useMemo } from 'react';
import {
  Container,
  ResultBadge,
  SubRow,
  SubTable,
  Table,
  Title,
  ToggleButton,
  SetScore,
  SetScoreBullet,
} from './styled';
import { toJS } from 'mobx';
import { observer } from 'mobx-react-lite';

const VSRecord = ({ data }) => {
  return (
    <Container>
      <Title>
        상대전적
        <span>※ 시즌 최근 5경기까지만 노출되며 배당률 및 기준점은 배트맨을 기준으로 합니다.</span>
      </Title>

      <Table>
        <colgroup>
          <col width={80} />
          <col width={120} />
          <col width={49} />
          <col width={22} />
          <col width={49} />
          <col width={120} />
          <col width={200} />
        </colgroup>
        <thead>
          <tr>
            <th>경기일</th>
            <th>홈팀</th>
            <th colSpan={3}>점수</th>
            <th>원정팀</th>
            <th>결과</th>
          </tr>
        </thead>
        <tbody>
          {data.map((value, key) => {
            return <VSRow key={key} item={value} />;
          })}
        </tbody>
      </Table>
    </Container>
  );
};

const VSRow = ({ item }) => {
  const { date, homeScore, awayScore, home, away, scores } = item;
  const [viewSub, setViewSub] = useState(false);

  const handleToggleSub = () => {
    // setViewSub(!viewSub);
  };
  return [
    <tr key={'row'} onClick={handleToggleSub} className={viewSub ? 'on' : ''}>
      <td>{date}</td>
      <td>{home.name_en}</td>
      <td className={homeScore > awayScore ? 'winner' : ''}>{homeScore}</td>
      <td>:</td>
      <td className={awayScore > homeScore ? 'winner' : ''}>{awayScore}</td>
      <td>{away.name_en}</td>
      <td>
        <div>
          {scores &&
            scores.map((score, index) => {
              return (
                <ResultBadge key={index} result={score.winner === 'h' ? 'WIN' : 'LOSS'}>
                  {score.winner === 'h' && '홈승'}
                  {score.winner === 'a' && '홈패'}
                </ResultBadge>
              );
            })}
        </div>
      </td>
    </tr>
  ];
};

export default VSRecord;
